export default {"src":"/_next/static/media/IT.2f8363ac.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};